import DOMPurify from 'dompurify';

/** Tags produced by TipTap StarterKit + custom captions/title marks */
const ALLOWED_TAGS = [
  'p',
  'br',
  'strong',
  'b',
  'em',
  'i',
  'u',
  's',
  'strike',
  'ul',
  'ol',
  'li',
  'blockquote',
  'code',
  'pre',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'hr',
  'a',
  'span',
];

const ALLOWED_ATTR = ['href', 'target', 'rel', 'class', 'data-type', 'style'];

/**
 * Sanitize rich-text HTML before persisting (TipTap transcriptions).
 * Strips scripts/event handlers; keeps a conservative TipTap allowlist.
 */
export function sanitizeRichTextHtml(html: string): string {
  if (!html || typeof html !== 'string') {
    return '';
  }

  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
    ADD_ATTR: ['data-type'],
  });
}

/**
 * Sanitize each language entry of a multilingual HTML map.
 */
export function sanitizeMultilingualHtml(
  record: Record<string, string>
): Record<string, string> {
  const result: Record<string, string> = {};
  for (const [lang, value] of Object.entries(record)) {
    result[lang] = sanitizeRichTextHtml(value || '');
  }
  return result;
}
